import {Component, Input} from '@angular/core';
import { NgIf } from '@angular/common';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NoImageComponent } from '../no-image/no-image.component';

@Component({
    selector: 'slm-pdf-viewer',
    templateUrl: './pdf-viewer.component.html',
    imports: [NgIf, PdfViewerModule, NoImageComponent]
})
export class PdfViewerComponent {
  @Input() src: string;

  public showNoImage: boolean;

  error(){
    this.showNoImage = true;
  }
}
